import { createReducer, on } from '@ngrx/store';
import { initialIbanRegionsState, IIbanRegionsState } from './ibanRegions.state';
import {  AddIbanRegionError, AddIbanRegionSuccess, DeleteIbanRegionError, DeleteIbanRegionSuccess, IbanRegionsLoaded, UpdateIbanRegionError, UpdateIbanRegionSuccess } from './ibanRegions.actions';

export const initialState: IIbanRegionsState = {
  ibanRegions: [],

};

const setIbanRegions = (state: IIbanRegionsState, { ibanRegions }: { ibanRegions: any[] }) => ({
  ...state,
  ibanRegions: ibanRegions 
});

const _ibanRegionsReducer = createReducer<IIbanRegionsState>(
  initialIbanRegionsState,
  on(IbanRegionsLoaded, setIbanRegions),
  on(AddIbanRegionSuccess, (state, { ibanRegion }) => ({
    ...state,
    ibanRegions: [...state.ibanRegions, ibanRegion],
    
  })),
  on(UpdateIbanRegionSuccess, (state, { ibanRegion }) => ({
    ...state,
    ibanRegions: state.ibanRegions.map(region =>
      region.id === ibanRegion.id ? ibanRegion : region
    ),
    
  })),
  on(DeleteIbanRegionSuccess, (state, { ibanRegionId }) => ({
    ...state,
    ibanRegions: state.ibanRegions.filter(region => region.id !== ibanRegionId),

  })),
  
);

export function ibanRegionsReducer(state: IIbanRegionsState, action): IIbanRegionsState {
  return _ibanRegionsReducer(state, action);
}
